import React from 'react';

export const SidebarLayout = ({ children }) => (
    <nav className="nxl-navigation">
        <div className="navbar-wrapper">
            {children}
        </div>
    </nav>
);
